<template>
  <div class="black--background">
    <div class="tcdc-app-bar ma-0">
      <v-container class="py-0 fill-height">

        <!-- Loading -->
        <loading :active.sync="isLoading" :is-full-page="true"></loading>

        <v-row align="center">
          <v-col class="text-left white--text pa-0 pl-md-3">
            <div class="d-flex flex-1">
              <img
                class="logo cursor-pointer hidden-md-and-up pa-3"
                src="../../assets/icons/tcdc-m-logo.png"
                :alt="defaultKeyword"
                @click="mainHandler"
              />
              <v-img
                eager
                class="logo cursor-pointer hidden-sm-and-down"
                :alt="defaultKeyword"
                position="left"
                height="46"
                src="../../assets/icons/tcdc-logo.png"
                contain
                @click="mainHandler"
              />
            </div>
          </v-col>
          <v-col class="text-center white--text py-0" v-if="$vuetify.breakpoint.mdAndUp">
            <div
              class="d-flex flex-1 align-center cursor-pointer justify-center"
              @click="locationHandler"
            >
              <img alt="tcdc-branch" class="marker-logo" src="../../assets/icons/marker-white.png" />
              <span class="text-uppercase bold pl-4" style="text-align: left;">{{ branchName }}</span>
              <div class="grey--text px-2 bold">|</div>
              <span class="grey--text bold mr-1" style="font-family: 'Poppins', sans-serif">Change branch</span>
              <v-icon style="width: 15px;" color="grey">mdi-menu-down</v-icon>
            </div>
          </v-col>
          <v-col class="text-right py-0 white--text d-flex flex-1">
            <div class="d-flex flex-1 align-center justify-end">
              <div class="d-flex align-center">
                <img
                    alt="tcdc-branch"
                        class="tcdc-sort-icon-hover search-icon px-2 cursor-pointer"
                        :src="searchBox ? require('../../assets/icons/search.png'):require('../../assets/icons/search-appbar.png')"
                        @click="onClickSearch"
                />
                <!--                    :src="events[0].event_type === item.name ? item.image_active:item.image_inactive"-->
                  <v-dialog
                          fullscreen
                          transition="fade"
                          v-model="searchBox"
                  >
                    <v-layout class="pa-5 d-flex justify-center align-center" style="background: rgba(0,0,0,.85); height: 100%;">
                      <v-flex xs12 md8 lg6>
                        <v-layout align-center pb-1 style="border-bottom: 2px solid #fff;">
                          <v-btn
                                  absolute
                                  right
                                  top
                                  icon
                                  color="#fff"
                                  @click="searchBox = false"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                          <v-icon large dark mr-2>mdi-magnify</v-icon>
                          <v-text-field
                                  id="search-box"
                                  flat
                                  solo
                                  hide-details
                                  color="#fff"
                                  height="60"
                                  background-color="transparent"
                                  :placeholder="$t('appbar.search')"
                                  style="color: white;"
                                  v-model="searchKeyword"
                                  @focusout="searchBox = false"
                                  @keyup.enter="onSearch"
                          ></v-text-field>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-dialog>
              </div>
              <v-btn class="mx-2" fab dark x-small color="white" v-if="lang === 'en'" @click="languageHandler('th')">
                <span class="black--text bold">TH</span>
              </v-btn>
              <v-btn class="mx-2" fab dark x-small color="white" v-if="lang === 'th'" @click="languageHandler('en')">
                <span class="black--text bold">EN</span>
              </v-btn>
              <v-btn fab dark x-small color="white" aria-label="menu" @click="menuHandler">
                <v-icon class="black--text">mdi-menu</v-icon>
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <v-slide-y-transition>
      <v-row v-if="visibleLocation" class="full-screen-app-bar black--background px-0 ma-0">
        <v-container>
          <v-row>
            <v-col class="black--background">
              <template v-for="(item, index) of locationList">
                <div
                  @click="() => branchHandler(item)"
                  :key="index.toString()"
                  class="text-uppercase tcdc-menu-title cursor-pointer tcdc-highlight-green bold"
                >{{ item[`name_${lang}`] }}</div>
              </template>
            </v-col>
          </v-row>
        </v-container>
      </v-row>
    </v-slide-y-transition>

    <v-slide-y-transition>
      <v-row v-if="visible" class="full-screen-app-bar black--background px-0 ma-0">
        <v-container>
          <v-row>
            <v-col
              cols="12"
              sm="6"
              md="4"
              lg="3"
              class="black--background"
              :class="{'pr-8': $vuetify.breakpoint.mdAndUp}"
            >
              <v-row>
                <v-col class="pt-2">
                  <v-expansion-panels flat accordion class="menu-expandable-bg" v-if="$vuetify.breakpoint.smAndDown">
                    <v-expansion-panel class="menu-expandable">
                      <v-expansion-panel-header
                              class="px-0 py-5 tcdc-panel-header cursor-pointer"
                      >
                        <span class="text-uppercase tcdc-menu-title bold menu-highlight">Change Branch</span>
                        <template v-slot:actions>
                          <v-icon class="white--text" size="medium">mdi-plus</v-icon>
                        </template>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <div
                                v-for="(item, i) in locationList" :key="i"
                                class="text-capitalize tcdc-menu-content bold"
                                @click="branchHandler(item)"
                        >{{ item[`name_${lang}`] }}</div>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                  <MainMenuCard
                    :items="menus"
                    @onClick="menuRouteHandler"
                    @onClickSubMenu="menuRouteHandler"
                  ></MainMenuCard>
                  <MainMenuCard
                    class="mt-n5"
                    v-if="siteMenu"
                    :api="true"
                    :optional="optionalMenu"
                    :items="siteMenu"
                    @onClick="menuRouteHandler"
                    @onClickSubMenu="menuRouteHandler"
                  ></MainMenuCard>
                </v-col>
              </v-row>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="8"
              lg="9"
              class="black--background"
              :class="{'pl-8': $vuetify.breakpoint.mdAndUp}"
            >
              <v-row :class="{'card-minus-margin': $vuetify.breakpoint.mdAndUp}">
                <template v-for="(item, index) of menuList">
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                    lg="4"
                    v-if="item.menuNameList.length > 0"
                    :key="index"
                    :class="{'pr-8': $vuetify.breakpoint.mdAndUp}"
                  >
                    <MenuCard
                      :title="item[`title_${lang}`]"
                      :items="item.menuNameList"
                      @onClickHeader="branchHandler(item)"
                      @onClick="menuRouteHandler"
                      @onClickSubMenu="menuRouteHandler"
                    ></MenuCard>
                  </v-col>
                </template>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-row>
    </v-slide-y-transition>
  </div>
</template>

<script>
import MenuCard from "../cards/MenuCard";
import MainMenuCard from "../cards/MainMenuCard";
import Loading from 'vue-loading-overlay'
import { mapState } from "vuex";
import { Utils } from "@/util/Utils";
import { defaultKeyword, eventBus } from "@/util/Constants"

export default {
  data: () => ({
    defaultKeyword,
    branch_id : 0,
    // currentBranch: "tcdc bangkok",
    tagName : 'all',
    searchBox: false,
    searchKeyword: "",
    visible: false,
    visibleLocation: false,
    isLoading: false,
    menus: [],
    optionalMenu: []
  }),
  mounted() {
    this.$nextTick(() => {
      document.documentElement.lang = this.$route.params.lang;
      this.loadDynamicMenusWithBranch();
    });
  },
  components: {
    MenuCard,
    MainMenuCard,
    Loading
  },
  async created() {
     let allBranch = true;
     if (this.$route.params.lang === 'en') {
       this.$store.commit('Branch/setLang', this.$route.params.lang)
     } else {
       // default lang
       this.$store.commit('Branch/setLang', 'th')
     }
    this.$i18n.locale = this.$route.params.lang === 'en' ? 'en':'th';
    this.$store.dispatch("Branch/getSiteLeftMenu");
    // if (this.allBranches.length === 0) {
       await this.$store.dispatch("Branch/getBranchAll");
     // }
     let otherBranches = [ ...this.allBranches ];
     otherBranches.shift();
    for (const b of otherBranches) {
       if (this.$route.path.indexOf(b.tag_name) > -1) {
           let params = { branch_id: b.branch_id, lang: this.lang };
           await this.$store.dispatch("ServiceMenu/getServiceMenuByBranch", params);
           // if (params.branch_id === 0 && this.$route.path.indexOf('visit-and-service-area') > -1) {
           //   await this.$store.dispatch("Branch/getBranchById", 1);
           // } else {
             await this.$store.dispatch("Branch/getBranchById", params.branch_id);
           // }
           allBranch = false;
           break
       }
     }
     if (allBranch) {
       // if (this.branchId !== 0) {
         let params = { branch_id: 0, lang: this.lang };
         const serviceMenu = this.$store.dispatch("ServiceMenu/getServiceMenuByBranch", params).catch(() => {});
         const branch = this.$store.dispatch("Branch/getBranchById", params.branch_id);
         // renderFcp reveals the page. Service pages render from the service payload,
         // so on those hold the reveal until it lands (the branch path above already
         // does); otherwise the content and footer jump a moment after they appear.
         // Other pages don't use it and keep revealing as soon as the branch is in.
         // The catch keeps a failed request from blocking the reveal.
         await Promise.all(this.$route.path.indexOf('/service') > -1 ? [serviceMenu, branch] : [branch]);
       // }
     }
     // await this.$store.dispatch("Branch/getBranchAll");
     let aboutParams = { branch_id: this.branchId, lang: this.lang };
     // this.$store.dispatch("ServiceMenu/getServiceMenuByBranch", params);
     if (this.$route.path.indexOf('/about/') === -1) {
       this.$store.dispatch("About/getAboutAllMenu", aboutParams)
     }

     eventBus.$emit('renderFcp')
  },
  computed:{
    ...mapState({
      siteMenu: state => {
        if (state.Branch.siteMenu) {
          return state.Branch.siteMenu;
        }
      },
      locationList: state => {
        if (state.Branch.branches.length > 0) {
          let mini = state.Branch.branches.find(item => item.branch_id === 5);
          let exceptMini = state.Branch.branches.filter(item => item.branch_id !== 5);
          let sorted = [
                  ...exceptMini,
                  mini
          ]
          return [
            ...sorted.map(branch => ({
              id: branch.branch_id,
              name_th: branch.branch_name_th,
              name_en: branch.branch_name_en,
              name: branch.branch_name_en,
              tag_name: branch.tag_name,
              path: '',
            }))
          ];
        }
      },
      menuList: state => {
        if (state.Branch.branches.length > 0) {
          let mini = state.Branch.branches.find(item => item.branch_id === 5);
          let exceptMini = state.Branch.branches.filter(item => item.branch_id !== 5);
          let sorted = [
            ...exceptMini,
            mini
          ]
          let menu = [
            ...sorted.map(branch => ({
              id : branch.branch_id,
              title_th : branch.branch_name_th,
              title_en : branch.branch_name_en,
              name : branch.branch_name_en,
              tag_name : branch.tag_name,
              menuNameList : [
                ...branch.menu.map(menu=>({
                  branch_id : menu.branch_id,
                  name_th : menu.title_th,
                  name_en : menu.title_en,
                  path : menu.slug_url,
                  subMenuList : [
                    ...menu.sub_menu.map(subMenu=>({
                      branch_id : menu.branch_id,
                      name_th : subMenu.title_th,
                      name_en : subMenu.title_en,
                      path : subMenu.slug_url,
                    }))
                  ]
                }))
              ],
            }))
          ];
          return menu;
        }
      },
      branchName: state => state.Branch.branch_name,
      branchId: state => state.Branch.branch_id,
      allBranches: state => state.Branch.branches,
      lang : state=> state.Branch.lang,
      serviceTopic : state=>{
        return [
          ...state.Membership.memberships.map(membership=>({
            title : membership.title,
            content : membership.description,
          }))
        ]
      }
    }),
    routeChanged: function () {
      return this.$route.path
    }
  },
  watch: {
    routeChanged: async function () {
      // let allBranch = true;
      // let otherBranches = [ ...this.allBranches ];
      // otherBranches.shift();
      // for (const b of otherBranches) {
      //   if (this.$route.path.indexOf(b.tag_name) > -1) {
      //     if (this.branchId !== b.branch_id) {
      //       let params = { branch_id: b.branch_id, lang: this.lang };
      //       await this.$store.dispatch("ServiceMenu/getServiceMenuByBranch", params);
      //       await this.$store.dispatch("Branch/getBranchById", params.branch_id);
      //       allBranch = false;
      //       break
      //     }
      //   }
      // }
      // if (allBranch) {
      //   if (this.branchId !== 0) {
      //     let params = { branch_id: 0, lang: this.lang };
      //     await this.$store.dispatch("ServiceMenu/getServiceMenuByBranch", params);
      //     await this.$store.dispatch("Branch/getBranchById", params.branch_id);
      //   }
      // }
      this.loadDynamicMenusWithBranch();
      if (this.$route.path.indexOf('/mini-tcdc/service/visit-and-service-area') !== -1) {
        this.$router.push(`/${this.lang}/mini-tcdc/about/mini-tcdc`)
      }
      if (this.$route.path.indexOf('/all/service/visit-and-service-area') !== -1) {
        this.$router.push(`/${this.lang}/about-main`)
      }
    }
  },
  methods: {
    loadDynamicMenusWithBranch() {
      const branch = Utils.getBranchNameById(this.branchId, this.allBranches);
      this.menus = [
        {
          name: "appbar.about",
          path: `/about-main`,
          branch_id: this.branchId
        },
        {
          name: "appbar.resourceCenter",
          subMenuList: [
            { name: "resourceCenter.article", path: `${branch}` +  "/service/resource-center/article" },
            { name: "resourceCenter.ebook", path: `${branch}` + "/service/resource-center/e-book" },
            {
              name: "resourceCenter.onlineEx",
              path: `${branch}` + "/service/resource-center/online-exhibition"
            },
            {
              name: "design world calendar",
              path: `${branch}` + "/service/resource-center/design-world-calendar"
            }
          ]
          // path: "/service/resource-center"
        },
        // {
        //   name: "my tcdc",
        //   website: "https://my.tcdc.or.th/"
        // },
        // {
        //   name: "network"
        // },
        {
          name: "appbar.career",
          website: "https://www.cea.or.th/th/career"
        },
        {
          name: "appbar.faqs",
          path: "/faqs"
        }
      ]
      // requirement 15/07/2021
      this.optionalMenu = [
        {
          name: 'footer.news',
          path: "/all/about/news",
          subMenuList: []
        }
      ]
    },
    menuHeaderHandler() {
      this.visible = false;
      // this.$router.push(`/${this.lang}`+"/home");
    },
    async branchHandler(item) {
      const branchName = item.name;
      this.visibleLocation = false;
      this.visible = false;
      if (this.branchName !== branchName) {
        this.isLoading = true;
        this.tagName = item.tag_name;
        this.branch_id = item.id;
        let params = { branch_id: item.id, lang: this.lang };
        // if (path === '/home') {
        await this.$store.dispatch("ServiceMenu/getServiceMenuByBranch", params)
        // }
        // await this.$store.dispatch("About/getAboutAllMenu", params);
        await this.$store.dispatch("Branch/getBranchById", this.branch_id)
        if (item.id === 5) {
          await this.$store.dispatch('Branch/getMiniByBranch', params);
        }
        let path;
        for (const b of this.allBranches) {
          if (this.branch_id === b.branch_id) {
            // if (this.branch_id === 0) {
            //   path = '';
            //   break;
            // }
            path = b.tag_name;
            break;
          }
        }
        let routeName = this.$route.name;
        if(routeName === 'AboutMain' && item.id !== 0) {
          routeName = 'AboutBranch'
        } else if (routeName === 'EventMain' && item.id !== 0) {
          routeName = 'EventBranch'
        }
        if (this.branch_id == 5) {
          this.isLoading = false;
          if (this.$route.path.includes('about/news')) {
            return this.$router.push('/'+this.lang+'/'+this.tagName+'/about/news')
          }
          return this.$router.push('/'+this.lang+'/mini-tcdc/about/mini-tcdc')
        }
        if (routeName === 'AboutMiniTcdc') {
          this.$router.push({ name: 'AboutBranch', params: { branch: path, lang: this.lang } }).catch(()=>{});
        } else {
          this.$router.push({ name: routeName, params: { branch: path, lang: this.lang } }).catch(()=>{});
        }
        // const fullPath = this.$route.path.replace(this.$route.params.branch, path);
        // console.log('push to', fullPath)
        // this.$router.push({ path: fullPath}).catch(()=>{});
        this.isLoading = false;
      }
    },
    async menuRouteHandler(item) {
      const website = item.website;
      const path = item.path;
      const branch = item.branch_id;
      const _this = this;
      function routerPush(url, branch_id) {
        // loaded
        _this.isLoading = false;
        let name = Utils.getBranchNameById(branch_id, _this.allBranches);
        if (url == '/faqs') {
            _this.$router.push(url).catch(()=>{})
        } else {
            _this.$router.push(`/${_this.lang}`+url).catch(()=>{})
        }
        // let pushUrl;
        // if (url.includes('resource-center') && !!name) {
        //   pushUrl = url.replace(name, '');
        //   _this.$router.push(pushUrl).catch(()=>{});
        // } else if (name && !url.includes(name)) {
        //   pushUrl = url + name;
        //   _this.$router.push(pushUrl).catch(()=>{})
        // } else {
        //   _this.$router.push(url).catch(()=>{})
        // }
      }

      if (item.name === 'about') {
        // loading
        this.isLoading = true;
        if (this.branchId === 0 || path.indexOf('about-main') > -1) {
          // all branches go to about-main
          let ab = { branch_id: 0, lang: this.lang };
          await this.$store.dispatch("ServiceMenu/getServiceMenuByBranch", ab)
          await this.$store.dispatch("Branch/getBranchById", 0)
          routerPush(path)
        } else {
          const dataParams = { branch_id: this.branchId, lang: this.lang };
          if (this.branchId === 5) {
            await this.$store.dispatch('Branch/getMiniByBranch', dataParams);
          }
          await this.$store.dispatch("About/getAboutAllMenu", dataParams);
          return await this.$store.dispatch("About/getAboutById",{
            id: this.branchId,
            lang: this.lang
          }).then(async res => {
            if (res.response_code == 200) {
              //set about data in form
              await this.$store.dispatch("About/setFormAbout", res.result);
              this.isLoading = false;
              this.visible = false;
              // if (template_id === 3) {
              if (this.branchId === 5) {
                return this.$router.push(`/${this.lang}`+`/mini-tcdc/about/mini-tcdc`);
              } else {
                for (const b of this.allBranches) {
                  if (res.result.branch_id === b.branch_id) {
                    return this.$router.push(`/${this.lang}`+`/${b.tag_name}/about`);
                  }
                }
              }
            } else {
              alert('data not found');
              this.isLoading = false;
            }
          })
        }
      }

      if (item.name === 'network') {
        // loading
        this.isLoading = true;
        this.visible = false;
        this.$store.dispatch("About/getAboutById",{
          id: this.branchId,
          lang: this.lang
        }).then(res => {
          if (res.response_code == 200) {
            this.$store.dispatch("About/setFormAbout", res.result);
          } else {
            console.log('data not found');
          }
        });
        await this.$store.dispatch("About/getAboutAllMenu", { branch_id: this.branchId, lang: this.lang });
        // loaded
        this.isLoading = false;
        let name = Utils.getBranchNameById(this.branchId, this.allBranches);
        this.$router.push(`/${this.lang}`+`/${name}/about#network`);
      }
      if (website) {
        // loaded
        this.isLoading = false;
        window.open(website);
      }
      if (path) {
        this.visible = false;

        // loading
        this.isLoading = true;

        // already use routePush function check
        // if (this.$route.path != path) {
          if (path.indexOf('/service') > -1) {
            if (branch) {
              await this.$store.dispatch("Branch/getBranchById", branch);
              await this.$store.dispatch("ServiceMenu/getServiceMenuByBranch", { branch_id: branch, lang: this.lang })
            } else {
              await this.$store.dispatch("Branch/getBranchById", this.branchId);
              await this.$store.dispatch("ServiceMenu/getServiceMenuByBranch", { branch_id: this.branchId, lang: this.lang })
            }
          }

          if (path == '/service/resource-center/e-book') {
            this.$store.dispatch('Article/onGetAllEbooks', { page: 1, lang: this.lang }).then(() => {
              routerPush(path);
            });

          } else if (path == '/service/resource-center/article') {
            this.$store.dispatch('Article/onGetAllArticles', { page: 1, lang: this.lang }).then(() => {
              routerPush(path);
            });

          } else if (path == '/service/resource-center/online-exhibition') {
            this.$store.dispatch('Article/onGetAllOnlineExhibitions', { branch: this.branchId, page: 1, lang: this.lang }).then(() => {
              routerPush(path);
            });

          } else if (path == '/service/resource-center/design-world-calendar') {
            this.$store.dispatch('Program/onGetDesignWorldCalendar', { lang: this.lang }).then(() => {
              routerPush(path);
            });

          } else if (path == '/faqs') {
            this.$store.dispatch('Faq/onGetAllFaqs', this.lang).then(() => {
              routerPush(path);
            });

          } else if (path.includes('home')) {
            await this.$store.dispatch("ServiceMenu/getServiceMenuByBranch", {
              branch_id: branch,
              lang: this.lang
            });
            this.$store.dispatch("Branch/getBranchById", branch).then(() => {
              routerPush(path, branch);
            });

          } else if (path.indexOf('/about') > -1 && path.indexOf('about-main') === -1) {
            await this.$store.dispatch("About/getAboutById",{
              id: branch,
              lang: this.lang
            }).then(res => {
              if (res.response_code == 200) {
                this.$store.dispatch("About/setFormAbout", res.result);
              } else {
                console.log('data not found');
              }
            });
            if (branch === 5) {
              await this.$store.dispatch('Branch/getMiniByBranch', { branch_id: branch, lang: this.lang });
            }
            await this.$store.dispatch("Branch/getBranchById", branch);
            await this.$store.dispatch("About/getAboutAllMenu", { branch_id: branch, lang: this.lang });
            routerPush(path, branch);

          } else {
            routerPush(path, this.branchId);
          }

        // }
        return;
      }
    },
    languageHandler(lang) {
      this.$store.commit('Branch/setLang', lang)
      // this.$i18n.locale = lang;
      this.$router.currentRoute.params.lang = lang
      // document.documentElement.lang = lang;
      this.$router.replace({ name: this.$router.name, params: this.$router.currentRoute.params })
      window.location.reload()
    },
    locationHandler() {
      this.visible = false;
      this.visibleLocation = !this.visibleLocation;
    },
    menuHandler() {
      this.visibleLocation = false;
      this.visible = !this.visible;
    },
    async mainHandler() {
      // change to all branch
      if (this.branchId !== 0) {
        this.isLoading = true;
        let params = { branch_id: 0, lang: this.lang };
        await this.$store.dispatch("ServiceMenu/getServiceMenuByBranch", params);
        await this.$store.dispatch("Branch/getBranchById", 0);
        this.isLoading = false;
      }
      if (this.$route.path != "/home") {
        this.$router.push(`/${this.lang}`+"/home");
        this.visible = false;
        this.visibleLocation = false;
      } else {
        this.visible = false;
        this.visibleLocation = false;
      }

    },
    onSearch() {
      if (this.searchKeyword) {
        this.$store.dispatch('Search/onSetKeyword', this.searchKeyword);
      }
      this.$router.push({ name: "Search", params: { lang: this.lang } });
      this.searchBox = false;
    },
    async onClickSearch() {
      if (this.$route.path === '/search') {
        this.$vuetify.goTo('#search-page');
      } else {
        this.searchKeyword = "";
        await this.$store.dispatch('Search/onResetKeyword');
        this.searchBox = !this.searchBox;
        setTimeout(() => {
          document.getElementById('search-box').focus();
        }, 100);
      }
    }
  }
};
</script>

<style lang="scss">
.tcdc-app-bar {
  height: 70px;
  width: 100vw;
  z-index: 1001;
  position: fixed;
  top: 0;
  background-color: black;
}
.full-screen-app-bar {
  width: 100vw;
  height: calc(100vh - 70px);
  min-height: calc(100vh - 70px);
  position: fixed;
  z-index: 1001;
  top: 70px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  overflow-y: scroll;
  transition: all 0.5s;
}
.tcdc-highlight-green {
  color: white;
}

.tcdc-highlight-green:hover {
  color: $tcdcGreen !important;
}
.main-menu-custom-padding {
  padding-right: 60px;
}
.card-minus-margin {
  margin-right: -28px;
}
.theme--light.v-input input#search-box,
input#search-box::placeholder {
  color: #fff;
  font-size: 2.5rem;
}
.theme--light.v-input input#search-box {
  max-height: unset;
  line-height: 60px;
}
</style>
